export default "__VITE_ASSET__1c3c96b9__"